<template>
    <div>
        <div class="profile-preview settings-field tw-flex tw-mb-8">
            <a @click="$emit('changeTab', 'avatar')"
                class="profile-img group tw-group  tw-w-24 tw-h-24 tw-rounded tw-relative tw-block tw-border-dotted tw-border-2 tw-mr-4">
                <img alt="" title="Chris Snoek" :src="settings.avatar" class="hover-opacity tw-rounded">
                <i aria-hidden="true"
                    class="far fa-pencil hover-opacity  tw-absolute tw-top-0 tw-right-0 tw-opacity-0 tw-m-2 tw-text-white tw-p-3 tw-rounded tw-bg-black tw-bg-opacity-50 group-hover:tw-opacity-100"></i>
            </a>
            <div class="profile-credentials tw-flex tw-justify-center tw-flex-col">
                <h3 class="tw-font-bold tw-text-2xl tw-mb-4">
                    {{ settings.firstname }} {{ settings.lastname }}
                </h3>
                <span class="secondary-c">
                    {{ settings.profile.company }}
                </span>
            </div>
        </div>

        <edit-input :label="$t('profile.header_image')" icon="fa fa-image">
            <image-uploader :return_file="true" :width="1380" :height="275" :display="false" @upload="saveHeader"
                @close="closeHeaderUploader" v-if="changing_header"></image-uploader>
            <div class="tw-group tw-relative" @click="openHeaderUploader">
                <img alt="" :title="$t('cropper.choose_file')" :src="settings.profile.header_image"
                    class="hover-opacity tw-rounded tw-object-cover tw-w-full tw-h-64">
                <i aria-hidden="true"
                    class="far fa-pencil hover-opacity  tw-absolute tw-top-0 tw-right-0 tw-opacity-0 tw-m-2 tw-text-white tw-p-3 tw-rounded tw-bg-black tw-bg-opacity-50 group-hover:tw-opacity-100"></i>
            </div>
        </edit-input>

        <edit-input :label="$t('fields.bio')" icon="fa fa-book">
            <form-textarea v-model="settings.profile.edit_description" name="description"></form-textarea>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.company')" icon="fa fa-building">
            <form-input v-model="settings.profile.company" name="company"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.privacy')" icon="fa fa-eye">
            <form-select v-model="settings.profile.hidden" :options="privacy_options" name_clean="name_clean"
                display_name="name"></form-select>
        </edit-input>


        <edit-input class="tw-mr-4 tw-w-full" :label="$t('profile.follow')" icon="fa fa-eye">
            <form-select v-model="settings.profile.follow" :options="follow_options" name_clean="name_clean"
                display_name="name"></form-select>
        </edit-input>
        <div @click="saveAccount" class="general-button">{{ $t('fields.save') }} </div>
    </div>
</template>

<script>
import EditInput from '../EditInput.vue';
import ImageUploader from '../../ui/ImageUploader';
import Notification from '../../../lib/models/Notification';
export default {
    name: 'AccountTab',

    components: {
        'edit-input': EditInput,
        'image-uploader': ImageUploader
    },
    props: ['settings'],
    data() {
        return {
            changing_header: false,
            privacy_options: [
                {
                    name: this.$t('fields.profile_visible'),
                    name_clean: 0
                },
                {
                    name: this.$t('fields.profile_hidden'),
                    name_clean: 1
                },
            ],
            follow_options: [
                {
                    name: this.$t('profile.anyone_follow'),
                    name_clean: 'followable'
                },
                {
                    name: this.$t('profile.accept_follow'),
                    name_clean: 'acceptfollow'
                },
                {
                    name: this.$t('profile.no_follow'),
                    name_clean: 'nofollow'
                },
            ],
        }
    },
    methods: {
        saveAccount() {
            this.$emit('saveAccount');
        },
        openHeaderUploader() {
            this.changing_header = true;
        },
        closeHeaderUploader() {
            this.changing_header = false;
        },
        saveHeader(data) {
            const formData = new FormData();
            formData.append('header_image', data.blob, data.filename);
            axios.post('/api/v3/profile/me/header', formData).then((response) => {
                const new_profile = response.data.data;
                new_profile.birth_date = moment(new_profile.birth_date, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD');
                HuddleUser.create({ data: new_profile });
                Notification.insert({
                    data: [
                        {
                            title: this.$t('profile.settings_saved'),
                        },
                    ],
                });
            }).catch(() => {
                Notification.insert({
                    data: [
                        {
                            title: this.$t('profile.settings_saved_failed'),
                        },
                    ],
                });
            });
        }
    },
}
</script>